import gql from 'graphql-tag'

export const QUERY_GET_SEGMENTS_ESTIMATES = gql`
  query GetSegmentsEstimates($segments_ids: [ID!]!) {
    getSegmentsEstimates(segments_ids: $segments_ids) {
      sms {
        cost
      }
    }
  }
`

export const QUERY_GET_CREDITS = gql`
  query Balance {
    balance(mode: SMS)
  }
`

export const QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS = gql`
  query CampaignsCountsPerStatus($isIndustry: Boolean, $industryIds: [ID]) {
    campaignsCountsPerStatus(mode: SMS, isIndustry: $isIndustry, industryIds: $industryIds) {
      ACTIVE
      SCHEDULED
      FINISHED
    }
  }
`

export const QUERY_GET_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      frequency {
        type
        interval
      }
      segments {
        _id
        name
        clients_qty
        clients_qty_at_campaign
        updated_at
        clients_refreshed_at
      }
      products {
        sku
        name
      }
      message {
        text
        send_date
        send_time
      }
      offers_schedule {
        _id
        name
        description
        segments
        end_date
        start_date
      }
      template_id
      ... on SMSChannelCampaign {
        industry {
          name
        }
      }
    }
  }
`

export const MUTATION_UPSERT_DRAFT_SMS_CAMPAIGN = gql`
  mutation UpsertDraftSMSCampaign($data: DraftSMSChannelCampaignInput!) {
    upsertDraftSMSCampaign(data: $data) {
      _id
      message
    }
  }
`

export const MUTATION_UPSERT_SMS_CAMPAIGN = gql`
  mutation UpsertSMSCampaign($data: SMSChannelCampaignInput!) {
    upsertSMSCampaign(data: $data) {
      _id
    }
  }
`
